// Respect reduced motion preference
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Navigation scroll effect
const nav = document.querySelector('#site-nav');
const hero = document.querySelector('.hero');

if (nav) {
  if (!hero) {
    nav.classList.add('scrolled');
  } else {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 100) {
        nav.classList.add('scrolled');
      } else {
        nav.classList.remove('scrolled');
      }
    }, { passive: true });
  }
}

// Mobile menu toggle
const navToggle = document.querySelector('.nav-toggle');
const navLinks = document.querySelector('.nav-links');

if (navToggle && navLinks) {
  navToggle.addEventListener('click', () => {
    const isOpen = navToggle.getAttribute('aria-expanded') === 'true';
    navToggle.setAttribute('aria-expanded', String(!isOpen));
    navToggle.setAttribute('aria-label', isOpen ? '開啟選單' : '關閉選單');
    navLinks.classList.toggle('is-open');

    // Prevent body scroll when menu is open
    document.body.style.overflow = isOpen ? '' : 'hidden';
  });

  // Close menu when clicking a link
  navLinks.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      navToggle.setAttribute('aria-expanded', 'false');
      navToggle.setAttribute('aria-label', '開啟選單');
      navLinks.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  });

  // Close menu on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && navLinks.classList.contains('is-open')) {
      navToggle.setAttribute('aria-expanded', 'false');
      navToggle.setAttribute('aria-label', '開啟選單');
      navLinks.classList.remove('is-open');
      document.body.style.overflow = '';
      navToggle.focus();
    }
  });
}

// Hero loaded animation
if (hero) {
  window.addEventListener('load', () => {
    hero.classList.add('loaded');
  });
}

// Scroll reveal animation (skip if reduced motion)
if (!prefersReducedMotion) {
  const revealElements = document.querySelectorAll('.reveal');

  const revealOnScroll = () => {
    const windowHeight = window.innerHeight;

    revealElements.forEach(element => {
      const elementTop = element.getBoundingClientRect().top;
      const revealPoint = windowHeight * 0.85;

      if (elementTop < revealPoint) {
        element.classList.add('active');
      }
    });
  };

  // Initial check
  revealOnScroll();

  // Throttled scroll handler using rAF
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        revealOnScroll();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
} else {
  // Show all reveal elements immediately
  document.querySelectorAll('.reveal').forEach(el => {
    el.classList.add('active');
  });
}

// Smooth scroll for navigation links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    const href = this.getAttribute('href');
    if (href === '#') return;
    const target = document.querySelector(href);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    }
  });
});

// Product image gallery
const productThumbnails = document.querySelectorAll('.product-thumbnail');
const productMainImg = document.getElementById('product-main-img');

if (productThumbnails.length > 0 && productMainImg) {
  productThumbnails.forEach(thumb => {
    thumb.addEventListener('click', () => {
      productMainImg.src = thumb.dataset.imageUrl;
      productMainImg.alt = thumb.dataset.imageAlt;
      productMainImg.removeAttribute('srcset');
      productThumbnails.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });
}

// Parallax effect for full image sections (throttled with rAF, skip if reduced motion)
if (!prefersReducedMotion) {
  const fullImageSections = document.querySelectorAll('.full-image-bg');

  if (fullImageSections.length > 0) {
    let parallaxTicking = false;

    const updateParallax = () => {
      fullImageSections.forEach(bg => {
        const section = bg.parentElement;
        const rect = section.getBoundingClientRect();
        const scrolled = (rect.top / window.innerHeight) * 30;
        bg.style.transform = `translateY(${scrolled}px)`;
      });
      parallaxTicking = false;
    };

    window.addEventListener('scroll', () => {
      if (!parallaxTicking) {
        window.requestAnimationFrame(updateParallax);
        parallaxTicking = true;
      }
    }, { passive: true });
  }
}
